import request from '@/utils/request'

const portalApi = {
  GetMusic: '/musics',
  GetImage: '/images',
  GetMv: '/mvs',
  GetBlog: '/blogs/stream',
  UploadText: '/upload_zhangxinyue/upload_text',
  CreateComment: '/create_comment',
  // 博客相关接口
  CreateTextBlog: '/blogs/create/text',
  CreateImageBlog: '/blogs/create/image', 
  CreateVideoBlog: '/blogs/create/video',
  GetBlogList: '/blogs/list',
  GetBlogDetail: '/blogs/detail',
}



export function getMusic () {
    return request({
      url: portalApi.GetMusic,
      method: 'get',
    //   params: parameter,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
  }

  export function getImage () {
    return request({
      url: portalApi.GetImage,
      method: 'get',
    //   params: parameter,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
  }

  export function getMv () {
    return request({
      url: portalApi.GetMv,
      method: 'get',
    //   params: parameter,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
  }

  
  export function getBlog (parameter) {
    return request({
      url: portalApi.GetBlog,
      method: 'get',
      params: parameter,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
  }


export function uploadText (data) {
    return request({
      url: portalApi.UploadText,
      method: 'post',
      data: data,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
  }

export function createComment (data) {
    return request({
      url: portalApi.CreateComment,
      method: 'post',
      data: data,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
  }

// 博客相关API
export function createTextBlog (data) {
  return request({
    url: portalApi.CreateTextBlog,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function createImageBlog (formData) {
  return request({
    url: portalApi.CreateImageBlog,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function createVideoBlog (formData) {
  return request({
    url: portalApi.CreateVideoBlog,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function getBlogList (params) {
  return request({
    url: portalApi.GetBlogList,
    method: 'get',
    params: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getBlogDetail (id) {
  return request({
    url: portalApi.GetBlogDetail,
    method: 'get',
    params: { id },
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}